import styled from 'styled-components'
import { Typography } from 'antd'

const CostReais = styled(Typography.Title)`
  color: #229552 !important;
`

const WrapButtons = styled.div`
  display: flex;
  width: 100%;
  > :nth-child(1) {
    width: 100%;
  }
`

export { CostReais, WrapButtons }
